import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Linkedin } from "lucide-react";
import { useI18n } from "../../lib/i18n";

export const Founder = () => {
  const { t } = useI18n();
  const f = t.founder;
  return (
    <section
      data-testid="founder-section"
      className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute -bottom-20 -left-20 w-[420px] h-[420px] rounded-full bg-brand-orange/[0.07] blur-[120px] pointer-events-none"
      />
      <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        {/* Photo */}
        <div className="lg:col-span-5">
          <div className="relative rounded-3xl overflow-hidden glass border border-white/[0.08] aspect-[4/5] max-w-md mx-auto lg:mx-0">
            <img
              src="/founder-rudrik-joshi.jpg"
              alt="Rudrik Joshi — Founder, Joshi FusionTech Media"
              width="640"
              height="800"
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-x-0 bottom-0 p-5 bg-gradient-to-t from-black/85 via-black/40 to-transparent">
              <div className="font-display font-bold text-white text-lg">Rudrik Joshi</div>
              <div className="font-mono text-[11px] tracking-[0.18em] uppercase text-brand-orange mt-1">
                {f.role}
              </div>
            </div>
          </div>
        </div>

        {/* Bio */}
        <div className="lg:col-span-7">
          <div className="flex items-center gap-3 mb-5">
            <span className="w-12 h-px bg-brand-orange" />
            <span className="label-mono">{f.kicker}</span>
          </div>
          <h2 className="font-display font-bold text-4xl md:text-5xl lg:text-[52px] tracking-tight text-white leading-[1.08]">
            {f.title}
          </h2>
          <p className="mt-7 text-white/72 text-[17px] leading-[1.7]">{f.intro}</p>
          <p className="mt-5 text-white/55 text-[15.5px] leading-[1.7]">{f.body}</p>

          <div className="mt-9 flex flex-wrap items-center gap-3">
            <Link
              to="/about"
              data-testid="founder-cta"
              className="btn-primary !py-3 !px-5 !text-sm"
            >
              {f.cta} <ArrowUpRight className="w-4 h-4" />
            </Link>
            <a
              href="https://www.linkedin.com/company/joshifusiontech"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary !py-3 !px-5 !text-sm"
            >
              <Linkedin className="w-4 h-4" />
              LinkedIn
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
